<template>
  <div class="px-2 mb-2">
    <div class="d-flex align-center mb-2">
      <p class="font-weight-500 font-size-18 ma-0 me-2">
        {{ $t('ai_features.organization_ai_settings.llm_settings') }}
      </p>
    </div>

    <v-form class="mt-8">
      <v-text-field
        v-model="llmForm.modelName"
        class="mb-4"
        dense
        hide-details
        outlined
        :disabled="isLoading"
        :label="$t('ai_features.organization_ai_settings.model_name')"
      />

      <v-text-field
        v-model="llmForm.modelVersion"
        class="mb-4"
        dense
        hide-details
        outlined
        :disabled="isLoading"
        :label="$t('ai_features.organization_ai_settings.model_version')"
      />

      <v-text-field
        v-model="llmForm.modelDeployment"
        class="mb-4"
        dense
        hide-details
        outlined
        :disabled="isLoading"
        :label="$t('ai_features.organization_ai_settings.model_deployment')"
      />

      <v-textarea
        v-model="llmForm.modelEndpoint"
        class="mb-4"
        dense
        hide-details
        no-resize
        outlined
        rows="3"
        :disabled="isLoading"
        :label="$t('ai_features.organization_ai_settings.model_endpoint')"
      />

      <v-textarea
        v-model="llmForm.modelAPIKey"
        class="mb-4"
        dense
        no-resize
        outlined
        persistent-hint
        rows="2"
        :clearable="false"
        :disabled="isLoading"
        :label="$t('ai_features.organization_ai_settings.model_api_key')"
        :hint="$t('ai_features.organization_ai_settings.model_api_key_hint')"
      />

      <div class="d-flex justify-end mt-8">
        <Button
          color="primary"
          :loading="isLoading"
          :text="$t('common.button.save')"
          @click="updateOrganizationAISettings"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import _ from 'lodash'
import api from '@/api'

import mixin from '@/mixins/mixin.vue'

import Button from '@/components/UI/Button'

export default {
  name: 'LLMSettings',

  mixins: [mixin],

  components: {
    Button,
  },

  props: {
    organization: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      llmForm: {
        modelAPIKey: '',
        modelDeployment: '',
        modelEndpoint: '',
        modelName: '',
        modelVersion: '',
      },
    }
  },

  mounted() {
    this.fetchOrganizationAISettings()
  },

  methods: {
    async fetchOrganizationAISettings() {
      this.isLoading = true
      try {
        const response = await api.ai.getOrganizationAISettings(
          this.organization._id
        )
        this.llmForm = { ...response.data }
      } catch (error) {
        this.showError(error)
      } finally {
        this.isLoading = false
      }
    },

    async updateOrganizationAISettings() {
      this.isLoading = true

      // If the API key field is empty, we omit it from the form to avoid overwriting it with an empty value
      const form = _.isEmpty(this.llmForm?.modelAPIKey)
        ? _.omit(this.llmForm, 'modelAPIKey')
        : this.llmForm

      try {
        const response = await api.ai.updateOrganizationAISettings(
          this.organization._id,
          form
        )
        this.llmForm = { ...response.data }
        this.showSuccess(
          this.$t('ai_features.user_access_control.settings_save_success')
        )
      } catch (error) {
        this.showError(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
